import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }

    const sessionId = match[1];
    api.post("/auth/session", { session_id: sessionId })
      .then((res) => {
        navigate("/", { state: { user: res.data } });
      })
      .catch(() => {
        navigate("/login");
      });
  }, [navigate]);

  return null;
}
